import React from "react";
import { Link } from "react-router-dom"

interface LocationTagsProps {
    label?: string,
    locationNames: string[],
    locationIds: string[]
    separator?: string
    storageId: string
}

const LocationTags: React.FC<LocationTagsProps> = ({ label, locationNames, locationIds, separator = ">", storageId }) => {

    if (locationNames.length === 0 || locationIds.length === 0) {
        return null
    }

    return (
        <div className="flex flex-wrap gap-2">
            {label && <b>{label}:</b>}
            {locationNames.map((locationName, i) => {
                const locationId = locationIds[i];
                if (locationName && locationId) {
                    return (
                        <React.Fragment key={locationId}>
                            <Link to={`/storage/locations/${locationId}`} className="link">{locationName}</Link>
                            {i < locationNames.length - 1 && separator}
                        </React.Fragment>
                    );
                }
                return null;
            })}
        </div>
    );
}

export default LocationTags
